import { useEffect, useState, Fragment, useRef } from "react";
import styled, { css } from "styled-components";
import "react-tooltip/dist/react-tooltip.css";
import {
  RWD_XL,
  RWD_LG,
  RWD_MD,
  RWD_SM,
  RWD_SS,
  RWD_XS,
} from "../../../utils/rwd";
import Lang from "../../../global/Lang";
import { specialPackageIdList } from "../configs";

const NavWrapper = styled.div`
  position: absolute;
  top: calc(2.5vw - 4px);
  right: 20px;
  ${RWD_MD(css`
    display: none;
  `)};
`;
const NavBar = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const Bar = styled.span`
  display: block;
  width: 28px;
  height: 4px;
  background-color: #37a5ff;
  margin: 3px;
  transition: 0.3s;
  border-radius: 50px;
  :nth-child(2) {
    width: 28px;
    background-color: #4f97ff;
  }
  :nth-child(3) {
    width: 16px;
    background-color: #6987ff;
  }
`;
const Hamburger = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  cursor: pointer;
  padding-top: 0.5vw;
  z-index: 1;

  ${(props) =>
    props.isActive &&
    css`
       {
        padding-left: 20px;
      }
      ${Bar} {
        border-radius: 50%;
        width: 4px;
      }
    `}
`;
const Navigation = styled.div`
  position: absolute;
  display: inline-block;
  top: 0;
  padding: 5px 20px;
  border-radius: 60px;
  background: linear-gradient(
    to left top,
    rgba(82, 148, 255, 0.2) 0%,
    rgba(118, 171, 255, 0.2) 100%
  );
  transform: scaleX(0);
  transform-origin: top right;
  opacity: 0;
  transition: 0.4s;
  pointer-events: none;
  ${(props) =>
    props.isOpen &&
    css`
      transform: scaleX(1) translateX(-40px);
      opacity: 1;
      pointer-events: auto;
    `}
`;
const Menu = styled.div`
  display: flex;
  width: 100%;

  div {
    width: 100%;
    display: flex;
    gap: 20px;
    justify-content: space-evenly;
    text-align: center;
    margin: 0;
    white-space: nowrap;
  }
`;

const WPButton = styled.div`
  border-radius: 60px;
  padding: 9px 24px;
  //background: linear-gradient(to bottom, #2f80ed 0%, #5620f0 100%);
  color: #fcfcfc;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    color: #0aecd1;
  }

  ${RWD_LG(css`
    padding: 5px;
    font-size: 12px;
  `)};
`;

//漢堡按鈕
const HamburgerNav = ({
  data,
  handlePreviewTransferPackage,
  handleSelectTransferPackage,
  WPbuttonHandler,
  language,
  setShareModalData,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleOpenShareModal = (data) => {
    if (data) {
      setShareModalData(data);
    }
  };

  //點擊外部關閉選單
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        isMenuOpen
      ) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMenuOpen]);

  return (
    <>
      {data?.Status === "running" && (
        <NavWrapper ref={navRef}>
          <NavBar>
            <Hamburger isActive={isMenuOpen} onClick={toggleMenu}>
              <Bar />
              <Bar />
              <Bar />
            </Hamburger>
            <Navigation isOpen={isMenuOpen}>
              <Menu>
                <>
                  {data.IsWaitingTransfer ? (
                    <WPButton
                      onClick={() => handlePreviewTransferPackage(data.GroupId)}
                    >
                      <Lang datakey="preview" defaultText="Preview" />
                    </WPButton>
                  ) : (
                    <div>
                      <WPButton
                        onClick={() =>
                          handleSelectTransferPackage(data.GroupId)
                        }
                      >
                        <Lang datakey="transfer" defaultText="Transfer" />
                      </WPButton>

                      {specialPackageIdList.includes(data.PackageId) && (
                        <WPButton onClick={() => WPbuttonHandler(data.GroupId)}>
                          {language === "En" ? "Dynamic Close" : "動態結算"}
                        </WPButton>
                      )}
                      <WPButton
                        top={
                          specialPackageIdList.includes(data.PackageId)
                            ? "9vw"
                            : "5vw"
                        }
                        onClick={() => handleOpenShareModal(data)}
                      >
                        Share
                      </WPButton>
                    </div>
                  )}
                </>
              </Menu>
            </Navigation>
          </NavBar>
        </NavWrapper>
      )}
    </>
  );
};
export default HamburgerNav;
